export default __webpack_public_path__ + "static/media/search_document_outline.edfef019.svg";